<div class="modal-container">
    <h2 mat-dialog-title>{{ isEditMode ? 'Edit' : 'Add' }} Knowledge Document</h2>

    <mat-dialog-content>
        <form [formGroup]="form" class="document-form">
            <mat-form-field appearance="outline" class="full-width">
                <mat-label>Title</mat-label>
                <input
                    matInput
                    formControlName="title"
                    placeholder="Enter document title"
                    maxlength="200" />
                <mat-hint>A descriptive title for this knowledge document</mat-hint>
                <mat-error *ngIf="form.get('title')?.hasError('required')">
                    Title is required
                </mat-error>
                <mat-error *ngIf="form.get('title')?.hasError('minlength')">
                    Title must be at least 3 characters
                </mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="full-width">
                <mat-label>Content</mat-label>
                <textarea
                    matInput
                    formControlName="content"
                    placeholder="Enter the knowledge content that the AI will use to answer questions..."
                    rows="12"
                    maxlength="10000"></textarea>
                <mat-hint>
                    The content the AI will reference when answering related questions
                </mat-hint>
                <mat-error *ngIf="form.get('content')?.hasError('required')">
                    Content is required
                </mat-error>
                <mat-error *ngIf="form.get('content')?.hasError('minlength')">
                    Content must be at least 10 characters
                </mat-error>
            </mat-form-field>

            <div class="info-box">
                <mat-icon>info</mat-icon>
                <span>
                    When you save this document, an AI embedding will be automatically generated
                    to enable semantic search. The AI assistant will use this document to answer
                    relevant questions.
                </span>
            </div>
        </form>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
        <button mat-button (click)="onCancel()" [disabled]="isSaving">Cancel</button>
        <button
            mat-raised-button
            color="primary"
            (click)="onSubmit()"
            [disabled]="!isFormValid">
            <mat-spinner *ngIf="isSaving" diameter="18" class="button-spinner"></mat-spinner>
            <span *ngIf="!isSaving">{{ isEditMode ? 'Update' : 'Create' }}</span>
            <span *ngIf="isSaving">Saving...</span>
        </button>
    </mat-dialog-actions>
</div>
